// extracted by mini-css-extract-plugin
module.exports = {"newsletter":"R_dt"};